"use client";

import styles from "./AuthorsMosaic.module.scss";
import { useHits } from "react-instantsearch";
import { AlgoliaAuthor } from "@repo/algolia/types";
import AuthorCard from "@/ui/AuthorCard/AuthorCard";

const AuthorsAlgoliaMosaic = () => {
  const { items } = useHits<AlgoliaAuthor>();

  return (
    <ol className={styles.list}>
      {items.map((author) => (
        <li key={author.objectID} className={styles.item}>
          <AuthorCard author={author} />
        </li>
      ))}
    </ol>
  );
};

export default AuthorsAlgoliaMosaic;
